/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archon_Finals_LabelInputs */



/**
* | output |
* | --- |
* | "Finals" |
*
* @param {Archon_Finals_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archon_finals_label = /** @type {((inputs?: Archon_Finals_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archon_Finals_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finale")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Finali")
	return /** @type {LocalizedString} */ ("Finals")
});